import formsSlice from './slice'

export default formsSlice.reducer
